<script>
  import Tooltip from './Tooltip.svelte';
  import TooltipIssue from './TooltipIssue.svelte';
  import TooltipDepartment from './TooltipDepartment.svelte';
  import { hoveredIssuePage, hoveredDepartmentPage } from '../state/uiState';
  import {
    hoveredIssuePageDetails,
    hoveredDepartmentPageDetails,
  } from '../data/dataAPI';
</script>

{#if $hoveredIssuePage !== undefined}
  <Tooltip width={200}>
    <TooltipIssue {...$hoveredIssuePageDetails} />
  </Tooltip>
{/if}

{#if $hoveredDepartmentPage !== undefined}
  <Tooltip width={200}>
    <TooltipDepartment {...$hoveredDepartmentPageDetails} />
  </Tooltip>
{/if}
